// import * as AuthRequests from "./requests/auth";
import * as AuthRequests from "./requests/auth2";
export { AuthRequests };
import { configService } from "./configService";
export { configService };

import UtilitiesRequests from "./requests/utilities";
export { UtilitiesRequests };

import CellarsRequests from "./requests/cellars";
export { CellarsRequests };
import CellarProductsRequests from "./requests/cellarProducts";
export { CellarProductsRequests };
import CellarExperiencesRequests from "./requests/cellarExperiences";
export { CellarExperiencesRequests };
import CellarReservationsRequests from "./requests/cellarReservations";
export { CellarReservationsRequests };

import CouponRequests from "./requests/coupon";
export { CouponRequests };

import ExperiencesRequests from "./requests/experiences";
export { ExperiencesRequests };
import ExperienceProductsRequests from "./requests/experienceProducts";
export { ExperienceProductsRequests };

import ExperienceAvailabilitiesRequests from "./requests/experienceAvailabilities";
export { ExperienceAvailabilitiesRequests };

import ExperienceAvailabilityRequests from "./requests/experienceAvailability";
export { ExperienceAvailabilityRequests };

import HostReservationRequests from "./requests/hostReservation";
export { HostReservationRequests };
import HostReservationIdRequests from "./requests/hostReservationId";
export { HostReservationIdRequests };
import GuestReservationIdRequests from "./requests/guestReservationId";
export { GuestReservationIdRequests };
import NoGuestReservationIdRequests from "./requests/noGuestReservationId";
export { NoGuestReservationIdRequests };

import ProductDetailsRequests from "./requests/productDetails";
export { ProductDetailsRequests };

import ProfileReservationsRequests from "./requests/profileReservations";
export { ProfileReservationsRequests };
import NoProfileReservationsRequests from "./requests/noProfileReservations";
export { NoProfileReservationsRequests };

import ProfileGiftsRequests from "./requests/profileGifts";
export { ProfileGiftsRequests };
import NoProfileGiftsRequests from "./requests/noProfileGifts";
export { NoProfileGiftsRequests };

import UtilitiesFunctions from "./utilitiesFunctions";
export { UtilitiesFunctions };

import ExperienceInquiryRequests from "./requests/experienceInquiry";
export { ExperienceInquiryRequests };

import { dwspayService } from "./dwspayService";
export { dwspayService };
